import React from "react";
import irisRoadData from "./data/irisRoadData";

import "./locationInformation.css";

export class GPSInformation extends React.Component {
  constructor(props) {
    super(props);

    this.state = { offset: 0, hasData: false };

    this.offsetChanged = this.offsetChanged.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.playerContext !== prevProps.playerContext) {
      this.props.playerContext.onGpsDataChanged(this.gpsDataChanged.bind(this));
    }
  }

  gpsDataChanged(gpsData) {
    this.setState(gpsData ? { ...gpsData, hasData: true } : { hasData: false });
  }

  offsetChanged(e) {
    const offsetSeconds = Math.max(Math.min(e.target.value, 5), -5);
    this.props.gpsData.setTimeOffset(offsetSeconds);
    this.props.playerContext.requestRefresh();
    this.setState({ offsetSeconds });
  }

  render() {
    if (!this.props.playerContext || !this.props.playerContext.gpsInformation)
      return null;

    return (
      <div className="locationInformation gpsInformation">
        <div className="infoColumn">
          <div>
            <label>Date</label>
            {this.state.hasData && this.state.dateSet && (
              <span>{this.state.dateDisplay}</span>
            )}
          </div>
          <div>
            <label>Time</label>
            {this.state.hasData && <span>{this.state.timeDisplay}</span>}
            <div>
              <label htmlFor="secondsOffset">Offset</label>
              <input
                id="secondsOffset"
                type="number"
                step={1}
                max={5}
                min={-5}
                value={this.state.offsetSeconds ?? 0}
                onChange={this.offsetChanged}
              />
              <span className="unit">s</span>
            </div>
          </div>
          <div>
            <label>Speed</label>
            {this.state.hasData && <span>{this.state.speed}</span>}
          </div>
        </div>
        <div className="infoColumn">
          <div>
            <label>Lat</label>
            {this.state.hasData && <span>{this.state.latitude}</span>}
          </div>

          <div>
            <label>Long</label>
            {this.state.hasData && <span>{this.state.longitude}</span>}
          </div>

          <div>
            <label>Heading</label>
            {this.state.hasData && <span>{this.state.direction}</span>}
          </div>
        </div>
      </div>
    );
  }
}

export class SLKInformation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hasData: false,
    };

    this.irisDataSet = false;

    this.dataChanged = this.dataChanged.bind(this);
  }

  componentDidUpdate() {
    if (this.irisDataSet) return;
    if (this.props.playerContext && this.props.irisRoadLayerConfig) {
      irisRoadData.initialise(
        this.props.irisRoadLayerConfig,
        this.props.playerContext
      );
      irisRoadData.onirisDataChanged(this.dataChanged.bind(this));
      this.irisDataSet = true;
    }
  }

  dataChanged(roadData) {
    if (roadData) {
      this.setState({
        roadNo: roadData.roadNo,
        roadName: roadData.roadName,
        cwy: roadData.cwy,
        slk: roadData.slk,
        hasData: true,
      });
    } else {
      this.setState({
        hasData: false,
      });
    }
  }

  render() {
    if (!this.props.playerContext || !this.props.playerContext.gpsInformation)
      return null;

    return (
      <div className="locationInformation slkInformation">
        {this.state.loading ? (
          <div>Loading Data...</div>
        ) : (
          <>
            <div className="infoColumn">
              <div>
                <label>Road No.</label>
                <span>{this.state.hasData && this.state.roadNo}</span>
              </div>
              <div>
                <label>Road Name</label>
                <span>{this.state.hasData && this.state.roadName}</span>
              </div>
              <div>
                <label>CWay</label>
                <span>{this.state.hasData && this.state.cwy}</span>
              </div>
            </div>
            <div className="infoColumn single">
              <div>
                <label>SLK</label>
                <span className="large">
                  {this.state.hasData &&
                    (
                      parseFloat(this.state.slk) +
                      (this.state.offset ?? 0) / 100
                    ).toFixed(2)}
                </span>
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
}
